import { render, staticRenderFns } from "./standartbiletentg.vue?vue&type=template&id=bf40e9aa&"
import script from "./standartbiletentg.vue?vue&type=script&lang=js&"
export * from "./standartbiletentg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports